export const LIB_VERSION = '18.1.2'; // autogenerated
//# sourceMappingURL=version.js.map